import React from "react";
import { connect } from "dva";
import PropTypes from 'prop-types'
import { modelUtils } from '@/utils';
import { } from '@/utils'
import { utils_tool, component_tool, framework_tool } from '@/tool'
import { Icon } from 'antd';
import TaskForm from './taskForm'
let { WizCollapse, WizRow, WizCol, WizInput, WizCard, WizCheckbox, WizSpin } = component_tool
const { TextArea } = WizInput;
let { WizContainer } = framework_tool;

const _getValue = (type, key) => {
    const values = {
        sendType: {
            '0': '站内通知',
            '1': '推送消息',
            '3': '短信通知',
            '4': '邮件通知',
            // '5': '企业微信',
            '6': '智能电话',
        },
        sendTypeIcon: {
            '0': 'cloud-server',
            '1': 'mobile',
            '3': 'message',
            '4': 'mail',
            '5': 'wechat',
            '6': 'phone',
        },
    }
    return values[type][key] || ''
}

class AdvancedSetting extends WizContainer {

    constructor(props) {
        super(props);
        this.state = {
            currentSceneKey: 'task',
            task: [],//通知信息
            recommend: [],//推荐信息
            notice: [],//通知信息
        }
        this.task = {},
            this.recommend = {},
            this.notice = {}
    }

    static propTypes = {
        bizType: PropTypes.number,        //业务类型
        bizId: PropTypes.number,              //业务id
    }
    static defaultProps = {
        bizType: null,        //业务类型
        bizId: 0,               //业务id
    }

    _componentDidMount() {
        this.props.onRef(this)
        if (this.props.bizId && this.props.bizType) {
            // this.doActions([
            //     {
            //         path: 'noticeTemplate/noticeInfoList',
            //         payload: {
            //             key: 'noticeInfoList',
            //             apiParams: {
            //                 bizType: this.props.bizType,
            //                 contentType: this.props.contentType,
            //                 dataStatus: this.props.dataStatus,
            //                 bizId: this.props.bizId,
            //             }
            //         }
            //     },
            // ]);
        }
    }

    _componentDidUpdate() {
    }
    propsAndStateOnChange = {
    };
    //提交模版
    _onSubmit(e) {

        this.taskForm.validateFields((err, values) => {
            if (!err) {
                let coverImg = values['coverImg']
                this.task['bizId'] = e['bizId']
                this.task['bizType'] = e['bizType']
                this.task['startDate'] = values['startDate'] && values['startDate'].format('YYYY-MM-DD HH:mm:ss')
                this.task['endDate'] = values['endDate'] && values['endDate'].format('YYYY-MM-DD HH:mm:ss')
                if (coverImg && coverImg.length) {
                    this.task['img'] = coverImg[0]['fileId']
                    delete values['coverImg']
                }
                this.task['importance'] = values['importance']
                this.task['enable'] = values['enable']
            }
        });
        if (this.task && this.task.bizId) {


            this.doActions([
                {
                    path: 'noticeTemplate/saveNoticeDefine',
                    payload: {
                        key: 'saveNoticeDefine',
                        apiParams: {
                            businessId: this.props.businessId,
                            bizType:this.props.bizType,
                            templateId: templateIdList,
                        }
                    }
                },
            ]);
        }
        return
    }
    _onReset() {
        log.info(`_onReset`)
    }
    _taskSubmit(params) {

    }
    _task() {
        if (this.state.currentSceneKey == 'task') {

            return <WizCard>

                <WizSpin tip={"加载中"} spinning={this.props.noticeTemplateLoading}>
                    <TaskForm key={this.props.bizId} submit={(v) => { this._taskSubmit(v) }} data={this.state.record} wrappedComponentRef={(form) => this.taskForm = form} />
                </WizSpin>
            </WizCard>
        }
    }
    _recommend() {
        if (this.state.currentSceneKey == 'recommend') {

            return <div><p>原型未定</p></div>
        }
    }
    _notice() {
        if (this.state.currentSceneKey == 'notice') {

            return <div><p>原型未定</p></div>
        }
    }
    _render() {
        const { currentSceneKey, record } = this.state
        let cardProps = {
            key: 5,
            headStyle: {
                fontSize: 14,
                color: 'rgba(24, 144, 255, 1)',
                background: '#FFFFFF',
                borderBottom: 1,
            },
            bodyStyle: {
                textAlign: 'center', verticalAlign: 'middle', padding: 1, margin: 1, //height: '67%'
            },
        };
        let tabList = [{ key: 'task', tab: '任务设置' }, { key: 'recommend', tab: '推荐设置' }, { key: 'notice', tab: '消息通知设置' }]

        return (
            <div>
                <WizCard key={currentSceneKey}
                    {...cardProps}
                    tabList={tabList}
                    defaultActiveTabKey={currentSceneKey}
                    onTabChange={key => {
                        this.setState({ currentSceneKey: key });
                    }}
                >
                    <WizSpin tip={'加载中'} spinning={this.props.noticeTemplateLoading}>
                        {this._task()}
                        {this._recommend()}
                        {this._notice()}
                    </WizSpin>
                </WizCard>
            </div>
        )
    }

}


const mapStateToProps = (state, ownProps) => {

    const { noticeTemplate } = state;
    const noticeInfoList = modelUtils.getModelEntity(noticeTemplate, "noticeInfoList");

    const load = modelUtils.getLoadingState(state, ['noticeTemplate']);
    return {
        noticeInfoList,
        //   submitAudit,
        ...load
    }
};

export default connect(mapStateToProps)(AdvancedSetting)
